<template>
  <div class="mt-6 rounded-xl bg-gradient-to-br from-accent/10 to-gradient-end/10 p-6 dark:from-accent/20 dark:to-gradient-end/20">
    <h3 class="mb-4 text-lg font-semibold text-ternary-dark dark:text-primary-light">
      {{ title }}
    </h3>
    <div class="space-y-3">
      <a
        v-for="link in socialLinks"
        :key="link.name"
        :href="link.url"
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center rounded-lg bg-gray-100/50 p-3 transition-all duration-300 hover:bg-gray-200/50 hover:shadow-soft dark:bg-gray-800/50 dark:hover:bg-gray-700/50"
      >
        <div class="mr-3 flex size-8 items-center justify-center rounded-full text-white" :class="link.bgColor">
          <component :is="link.icon" class="size-4" />
        </div>
        <div>
          <p class="text-sm font-medium text-ternary-dark dark:text-ternary-light">{{ link.name }}</p>
          <p class="text-xs text-gray-600 dark:text-gray-400">{{ link.subtitle }}</p>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
interface SocialLink {
  name: string
  url: string
  icon: any
  bgColor: string
  subtitle: string
}

interface Props {
  title?: string
  socialLinks: SocialLink[]
}

withDefaults(defineProps<Props>(), {
  title: 'Connect & Follow',
})
</script>
